module.exports = __webpack_public_path__ + "img/logo.c906e656.svg";